import moment from 'moment';

export default (value, format, isHour) => {

	if (isHour) {

		const [
			hours,
			minutes,
			seconds
		] = value.split(':');

		const instance = moment().hours(hours).minutes(minutes);

		if (seconds) {
			instance.seconds(seconds);
		}

		return instance.format(format);

	}

	return moment(value).format(format);

};



// WEBPACK FOOTER //
// ./sources/filters/date.js